import React, { useContext } from "react";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import { FiMapPin, FiMail, FiPhone, FiClock, FiLinkedin, FiInstagram, FiTwitter, FiArrowUp } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";

export default function IntegratedRichFooter() {
  const appContext = useContext(AppContext);

  const contactData = {
    address: "Tabata Kimanga - Dar es Salaam, Tanzania. Remotely Distributed Globally.",
    email: "info@werenium.com",
    phone: "+255 758 779 913",
    whatsapp: "255758779913", // Format for WhatsApp link
    hours: {
      weekday: "Mon-Fri (08:00-18:00)",
      weekend: "Sat & Sun (08:00-14:00)"
    }
  };

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="footer-fusion">
      <style>{`
        .footer-fusion {
          background: #0d0d0d;
          color: #ffffff;
          padding: 100px 0 40px;
          font-family: 'Inter', sans-serif;
        }

        /* ── TOP SECTION: EXACT DESIGN FROM SCREENSHOT ── */
        .info-strip-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          text-align: center;
          padding-bottom: 80px;
          border-bottom: 1px solid rgba(255,255,255,0.05);
          margin-bottom: 80px;
        }

        .info-col {
          padding: 0 40px;
          position: relative;
        }

        .info-col:not(:last-child)::after {
          content: "";
          position: absolute;
          right: 0;
          top: 10%;
          height: 80%;
          width: 1px;
          background: rgba(255, 255, 255, 0.08);
        }

        .info-icon {
          font-size: 3.5rem;
          margin-bottom: 25px;
          color: #fff;
          stroke-width: 1px;
        }

        .info-label {
          font-size: 1.6rem;
          font-weight: 700;
          margin-bottom: 15px;
          letter-spacing: -0.02em;
        }

        .info-value {
          font-size: 1rem;
          color: #888;
          line-height: 1.6;
          text-decoration: none;
        }

        .info-value a {
          color: inherit;
          text-decoration: none;
          display: block;
          transition: 0.3s;
        }

        .info-value a:hover {
          color: var(--primaryColor);
        }

        /* ── BOTTOM SECTION: MODERN BRANDING & NAV ── */
        .footer-base-grid {
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr 1fr;
          gap: 60px;
          align-items: flex-start;
        }

        .footer-logo-img {
          max-height: 70px;
          margin-bottom: 30px;
          cursor: pointer;
        }

        .base-tagline {
          color: #666;
          font-size: 0.95rem;
          line-height: 1.7;
          max-width: 300px;
          margin-bottom: 30px;
        }

        .social-row {
          display: flex;
          gap: 12px;
        }

        .social-link {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          border: 1px solid #222;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          transition: 0.3s;
          background: rgba(255,255,255,0.02);
        }

        .social-link:hover {
          background: var(--primaryColor);
          border-color: var(--primaryColor);
          transform: translateY(-3px);
        }

        .base-header {
          font-size: 0.8rem;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          color: var(--primaryColor);
          margin-bottom: 25px;
        }

        .base-nav {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .base-nav li { margin-bottom: 12px; }
        .base-nav a {
          color: #888;
          text-decoration: none;
          font-size: 0.95rem;
          transition: 0.3s;
          cursor: pointer;
        }

        .base-nav a:hover { color: #fff; padding-left: 5px; }

        .footer-copyright {
          margin-top: 80px;
          padding-top: 30px;
          border-top: 1px solid rgba(255,255,255,0.03);
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #444;
          font-size: 0.85rem;
        }

        .btn-top {
          background: none;
          border: 1px solid #222;
          color: #fff;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          cursor: pointer;
          transition: 0.3s;
        }

        .btn-top:hover { background: var(--primaryColor); border-color: var(--primaryColor); }

        @media (max-width: 992px) {
          .info-strip-grid { grid-template-columns: 1fr; gap: 60px; }
          .info-col::after { display: none; }
          .footer-base-grid { grid-template-columns: 1fr 1fr; }
        }

        /* ── RESPONSIVE ALIGNMENT FOR SMALLER DEVICES ── */
        @media (max-width: 768px) {
          .info-strip-grid {
            text-align: left;
            gap: 40px;
            padding-bottom: 50px;
            margin-bottom: 50px;
          }

          .info-col {
            padding: 0;
          }

          .footer-base-grid {
            grid-template-columns: 1fr;
            text-align: left;
            gap: 40px;
          }

          .base-tagline {
            margin-left: 0;
            margin-right: 0;
          }

          .social-row {
            justify-content: flex-start;
          }

          .footer-copyright {
            flex-direction: column;
            align-items: flex-start;
            gap: 20px;
          }
        }
      `}</style>

      <div className="container">
        
        {/* Top: The Triple Column Strip */}
        <div className="info-strip-grid">
          <div className="info-col">
            <FiMapPin className="info-icon" />
            <h3 className="info-label">Address</h3>
            <p className="info-value">{contactData.address}</p>
          </div>

          <div className="info-col">
            <FiMail className="info-icon" />
            <h3 className="info-label">Send Message</h3>
            <div className="info-value">
              <a href={`mailto:${contactData.email}`}>{contactData.email}</a>
              <a href={`tel:${contactData.phone}`}>{contactData.phone}</a>
            </div>
          </div>

          <div className="info-col">
            <FiClock className="info-icon" />
            <h3 className="info-label">Opening Hour</h3>
            <div className="info-value">
              <div>{contactData.hours.weekday}</div>
              <div>{contactData.hours.weekend}</div>
            </div>
          </div>
        </div>

        {/* Bottom: Modern Brand & Navigation */}
        <div className="footer-base-grid">
          <div className="brand-side">
            <img src={logo} alt="Werenium" className="footer-logo-img" onClick={() => appContext.navTo({item: 'hero'})} />
            <p className="base-tagline">
              We Bring Ideas and Visions to Life.
              <br/> We code, You Grow.
            </p>
            <div className="social-row">
              <a href="#" className="social-link"><FiLinkedin /></a>
              <a href="#" className="social-link"><FiInstagram /></a>
              <a href={`https://wa.me/${contactData.whatsapp}`} className="social-link" target="_blank" rel="noreferrer">
                <FaWhatsapp />
              </a>
            </div>
          </div>

          <div>
            <h4 className="base-header">Services</h4>
            <ul className="base-nav">
              <li><a onClick={() => appContext.navTo({item: 'services', subItem: 'software'})}>Software Development</a></li>
              <li><a onClick={() => appContext.navTo({item: 'services', subItem: 'tax-compliance'})}>Tax Compliance</a></li>
              <li><a onClick={() => appContext.navTo({item: 'services', subItem: 'enterprise'})}>Enterprise Solutions</a></li>
            </ul>
          </div>

          <div>
            <h4 className="base-header">Company</h4>
            <ul className="base-nav">
              <li><a onClick={() => appContext.navTo({item: 'about_us'})}>Our Story</a></li>
              <li><a onClick={() => appContext.navTo({item: 'portfolio'})}>Portfolio</a></li>
              <li><a onClick={() => appContext.navTo({item: 'contact_us'})}>Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="base-header">Support</h4>
            <ul className="base-nav">
              <li><a href={`tel:${contactData.phone}`}>Call Center</a></li>
              <li><a href={`https://wa.me/${contactData.whatsapp}`} target="_blank" rel="noreferrer">WhatsApp Chat</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-copyright">
          <p>© {new Date().getFullYear()} Werenium. All Rights Reserved</p>
          <button onClick={scrollToTop} className="btn-top" aria-label="Scroll to top">
            <FiArrowUp size={20} />
          </button>
        </div>
      </div>
    </footer>
  );
}